import React from 'react'
import cta from '../../Assests/images/section/cta.png'
// import SplitText from "../Common/SplitText";
import AnimatedContent from "../Common/AnimatedContent";

const FooterHead = () => {
  return (
    <section className="section-CTA">
    <div className="tf-container">
        <div className="row">
            <div className="col-12">
                <div className="content-inner">
                    <img src={cta} loading="lazy" alt="CoOwnSpace - Talk to our expert" />
                    <div className="content">
                        <h2 className="title balance text-anime-wave text-start text-white" >Need help? Talk to our expert.</h2>
                    {/* <SplitText
                                    text="Need help? Talk to our expert."
                                    className="title balance text-anime-wave text-start text-white"
                                    delay={30}
                                    animationFrom={{ opacity: 0, transform: "translate3d(0,50px,0)" }}
                                    animationTo={{ opacity: 1, transform: "translate3d(0,0,0)" }}
                                    easing="easeOutCubic"
                                    threshold={0.2}
                                    rootMargin="-50px"

                                /> */}
                                <AnimatedContent
                                distance={5}
                                direction="vertical"
                                reverse={false}
                                config={{ tension: 80, friction: 20 }}
                                initialOpacity={0.2}
                                animateOpacity
                                scale={1.1}
                                threshold={0.2}
                            >
                                <p
                                    className="text-1 text-white animate__fadeInUp animate__animated">
                                   If you’re looking to buy a home. We’ll help you
                            make
                            the most money
                            possible.
                                </p>
                            </AnimatedContent>
                        {/* <h4 className="text-white mb-8 ">Need help? Talk to our expert.</h4>
                        <p className="text-white text-1">If you’re looking to buy a home. We’ll help you
                            make
                            the most money
                            possible.</p> */}
                    </div>
                    <a href="/contact" className="tf-btn style-2 fw-6 ">Contact us</a>
                </div>
            </div>
        </div>
    </div>
</section>
  )
}

export default FooterHead